import type { CabinBaggageDetails } from '@eti/schema-types';

export const resolveTravelerLabel = (
  t: (key: any, ...params: any[]) => string,
  travelerId: string,
  travelerName?: string | null,
) => travelerName ?? t('TravelerDescription.Header', Number(travelerId) + 1);
export const resolveBaggageForTraveler = (
  t: (key: any, ...params: any[]) => string,
  baggageDetails: any,
  bundleBaggageDetails?: any,
) => {
  const { pieces, weight, weightUnit } = baggageDetails || bundleBaggageDetails;
  return pieces
    ? t('Cart.Baggage.Pieces.Value', pieces, weight, weightUnit)
    : t('Cart.Baggage.Weight.Value', weight, weightUnit);
};

export const resolveBaggageForTravelerPaymentCart = (
  t: (key: any, ...params: any[]) => string,
  baggageDetails: any,
  secondBagSelectionForTraveler: any,
) => {
  const { pieces, weight, weightUnit } = baggageDetails || {};
  const { pieces: piecesSecondBag, maxWeight: weightSecondBag } =
    secondBagSelectionForTraveler || {};

  const secondBagQuantity = weight === weightSecondBag ? piecesSecondBag : 0;
  return pieces
    ? t('Cart.Baggage.Pieces.Value', pieces + secondBagQuantity, weight, weightUnit)
    : t('Cart.Baggage.Weight.Value', weight, weightUnit);
};

export const resolveSecondBagForTravelerPaymentCart = (
  t: (key: any, ...params: any[]) => string,
  secondBagSelectionForTraveler: any | null,
) => {
  const {
    pieces: piecesSecondBag,
    maxWeight: weightSecondBag,
    weightUnit: weightUnitSecondBag,
  } = secondBagSelectionForTraveler || {};

  return piecesSecondBag
    ? t('Cart.Baggage.Pieces.Value', piecesSecondBag, weightSecondBag, weightUnitSecondBag)
    : t('Cart.Baggage.Weight.Value', weightSecondBag, weightUnitSecondBag);
};

export const resolveSecondBaggageForTraveler = (
  t: (key: any, ...params: any[]) => string,
  baggageDetails: any,
) => {
  const {
    piecesOfSecondBag,
    weightOfSecondBag,
    weightUnitOfSecondBag,
    pieces,
    maxWeight,
    weightUnit,
  } = baggageDetails;

  return (
    (piecesOfSecondBag &&
      t(
        'Cart.Baggage.Pieces.Value',
        piecesOfSecondBag,
        weightOfSecondBag,
        weightUnitOfSecondBag,
      )) ||
    (pieces && t('Cart.Baggage.Pieces.Value', pieces, maxWeight, weightUnit))
  );
};

export const resolveCabinBaggageForTraveler = (
  t: (key: any, ...params: any[]) => string,
  cabinBaggageDetails: CabinBaggageDetails | undefined | null,
  bundleCabinBaggageDetails?: any,
) => {
  if (cabinBaggageDetails || bundleCabinBaggageDetails) {
    const { pieces = 1, weight, weightUnit } = cabinBaggageDetails || bundleCabinBaggageDetails;
    return weight && weightUnit
      ? t('Cart.CabinBaggage.Included.PiecesAndWeight', pieces, weight, weightUnit)
      : t('Cart.CabinBaggage.Included.PiecesWithoutWeight', pieces);
  }
  return t('Cart.CabinBaggage.Included.PiecesWithoutWeight', 1);
};
